<div class="container d-flex justify-content-center align-items-center" style="min-height: 60vh">
  <div class="form-section shadow p-4 rounded">

    <h3 class="mb-3">Login</h3>

    <!-- Success / Error Message -->
    @if (message) {
      <div
        class="alert alert-dismissible fade show"
        [class.alert-success]="messageType === 'success'"
        [class.alert-danger]="messageType === 'error'"
        role="alert">
        {{ message }}
        <button type="button" class="btn-close" (click)="message = ''"></button>
      </div>
    }

    <!-- Login Form (same format as Register) -->
    <form id="loginForm" (ngSubmit)="onSubmit()" #regForm="ngForm">

      <!-- WhatsApp Number -->
      <div class="mb-3">
        <label for="whatsapp" class="form-label">
          WhatsApp Number
          <small class="text-muted">(Include country code e.g., +1 for US)</small>
        </label>

        <div class="input-group">
          <span class="input-group-text bg-success text-white">
            <i class="fab fa-whatsapp"></i>
          </span>

          <input
            type="tel"
            class="form-control"
            id="whatsapp"
            name="whatsapp"
            [(ngModel)]="loginData.whatsapp"
            placeholder="+1234567890"
            pattern="^\+\d{10,15}$"
            required
            />
        </div>
      </div>

      <!-- Submit Button -->
      <div class="d-grid gap-2">
        <button type="submit"
          class="btn btn-dark py-2"
          [disabled]="loading || !regForm.valid">

          @if (loading) {
            <span
              class="spinner-border spinner-border-sm me-2"
              role="status">
            </span>
          }

          {{ loading ? 'Sending OTP...' : 'Submit' }}
        </button>
      </div>

    </form>
    <hr />
    <!-- Google Login -->
    <button class="btn btn-dark py-2 google-btn" (click)="googleLogin()">
      Sign in with Google
    </button>
  </div>
</div>
